import './imageCircle.scss';

export const ImageCircle = angular
    .module('checkout.components.orderSummary.imageCircle', [])
    .component('imageCircle', {
        template: `
            <img
                class="image-circle"
                ng-src="{{$ctrl.image || '//d3dl6qv39aj0xv.cloudfront.net/assets/tcp-no-image.jpg'}}" />
        `,
        bindings: {
            image: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/orderSummary/components/imageCircle/imageCircle.js